import { z } from 'zod'
import { ElectricityProductionMethod } from '@/common'

export const selectedElectricityProductionMethodSchema = z.object({
  type: z.enum(ElectricityProductionMethod),
  isRenewable: z.boolean().optional(),
  info: z.string().nullable().optional()
})

export type SelectedElectricityProductionMethod = z.infer<
  typeof selectedElectricityProductionMethodSchema
>

export const selectedElectricityProductionMethods = z.array(
  selectedElectricityProductionMethodSchema
)

export type SelectedElectricityProductionMethodsPayload = z.infer<
  typeof selectedElectricityProductionMethods
>
